import { useSelector } from 'react-redux'
import { FORMAT_TYPES } from '.'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import {
  formatVal,
  formatValWithCurrencyUnit,
  valToPercent,
} from '../../../../helpers/value'
import { EMPTY_VALUE } from '../../../../utils/common'

const timesUnit = ['times', 'lần']

const formatValue = (
  value,
  formatType,
  locale,
  exchangeRate = 1,
  multiplier = 1,
  decimalLength = 2,
) => {
  switch (formatType) {
    case FORMAT_TYPES.DECIMAL:
      return formatVal(value, locale)
    case FORMAT_TYPES.PERCENTAGE:
      return valToPercent(value, locale, false, false, 2, true)
    case FORMAT_TYPES.CURRENCY_EXCHANGE:
      return formatVal(
        formatValWithCurrencyUnit(value, exchangeRate, multiplier),
        locale,
        undefined,
        decimalLength,
      )
    default:
      return value
  }
}

const ItemHighlight = ({ value, unit, formatType }) => {
  const locale = useSelector((state) => state.i18n.locale)

  const { decimalLength, latestAvgExchangeRate, multiplier, formatedUnit } =
    useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)

  const valueFormat = formatValue(
    value,
    formatType,
    locale,
    latestAvgExchangeRate,
    multiplier,
    decimalLength,
  )

  return (
    <>
      {valueFormat}{' '}
      {valueFormat !== EMPTY_VALUE &&
        (unit === 'VND' ? formatedUnit : !timesUnit.includes(unit) && unit)}
    </>
  )
}

export default ItemHighlight
